var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3577_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8011 2.63152C23.6634 2.12289 23.395 1.65919 23.0224 1.28659C22.6498 0.913989 22.1861 0.645494 21.6775 0.507838C19.8154 0 12.3212 0 12.3212 0C12.3212 0 4.82658 0.015372 2.96451 0.52321C2.45588 0.660874 1.99218 0.929383 1.6196 1.302C1.24701 1.67462 0.978544 2.13834 0.840925 2.64698C0.277691 5.95552 0.0592028 10.997 0.856391 14.1732C0.994024 14.6818 1.2625 15.1455 1.63508 15.5181C2.00766 15.8907 2.47135 16.1592 2.97998 16.2968C4.84205 16.8047 12.3365 16.8047 12.3365 16.8047C12.3365 16.8047 19.8308 16.8047 21.6928 16.2968C22.2014 16.1592 22.6651 15.8907 23.0377 15.5181C23.4103 15.1455 23.6788 14.6818 23.8164 14.1732C24.4105 10.8599 24.5936 5.82158 23.8011 2.63152Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93579 12.0032L16.1528 8.40225L9.93579 4.80127V12.0032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3577_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.8717,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.79888f09913414a42633fcbacb79a9f7.svg";
export { ForwardRef as ReactComponent };